import { createStytchB2BUIClient } from '@stytch/nextjs/b2b/ui'
import { stytchClientConfig } from '../stytch'

const getCookieDomain = (): string => {
  if (typeof window === 'undefined') return ''
  const hostname = window.location.hostname
  return hostname.endsWith('.happy-health.net') ? '.happy-health.net' : ''
}

const cookieDomain = getCookieDomain()

// optional object for configuring SDK cookie behavior, currently showing defaults
const stytchOptions = {
  cookieOptions: {
    opaqueTokenCookieName: 'stytch_session',
    jwtCookieName: 'stytch_session_jwt',
    path: '/',
    availableToSubdomains: Boolean(cookieDomain),
    domain: cookieDomain
  }
}

export const stytchB2bClient = createStytchB2BUIClient(
  stytchClientConfig.publicToken,
  stytchOptions
)
